<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="name">Название компании</label>
    <input
      type="text"
      class="form-control"
      id="name"
      placeholder="Введите название вашей компании"
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)"
    >
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'company-name-field',
  props: {
    value: String,
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// CompanyName.vue?ce1f5a28